import React, { useState } from "react";
import { Router, Route, Switch } from "react-router-dom";
import { Container } from "reactstrap";

import Loading from "./components/Loading";
import NavBar from "./components/NavBar";
import Footer from "./components/Footer";
import Home from "./views/Home";
import Profile from "./views/Profile";
import Permissions from "./views/Permissions";
import Login from "./components/Login";
import OrgManagement from "./views/OrgManagement";
import Applications from "./views/Applications";
import Tenants from "./views/Tenants";
import { useAuth0 } from "@auth0/auth0-react";
import history from "./utils/history";
import { returnTextByOrg } from "./utils/textHelpers";

// styles
import "./App.css";

// fontawesome
import initFontAwesome from "./utils/initFontAwesome";
initFontAwesome();

const App = () => {
  const { isLoading, error } = useAuth0();
  const [hideEmployees, setHideEmployees] = useState(true);
  const [hideCustomers, setHideCustomers] = useState(true);

  if (error) {
    return <div>Oops... {error.message}</div>;
  }

  if (isLoading) {
    return <Loading />;
  }

  const hostname = window.location.hostname;
  const splithostname = hostname.split(".");
  let subdomain = splithostname[0];
  let organization,
    connection = "";
  if (
    splithostname.length > 3 ||
    (splithostname.length > 1 && splithostname[1].includes("localhost"))
  ) {
    organization = connection = subdomain;
  }

  return (
    <Router history={history}>
      <style>
        {`
            #bg-img {
              // height: 100vh;
              // width: 100vw;
              width: 100%;
              height: 100%;
              // height: 100vh;
              z-index: -5;
              position: absolute;
              opacity: 1.0;
              object-fit: cover;
              
            }
              .bg {
              width: 100%;
              height: 100%;
              // height: 100vh;
              z-index: -4;
              position: absolute;
              // opacity: 0.8;
              object-fit: cover;
              // background-color: black;
              ${returnTextByOrg(organization, {
                nisc: "background-color:black; opacity: 0.7;",
                southcentralpower: "background-color:black; opacity:0.7;",
                austinutilities: "background-color: black; opacity: 0.8;",
                oec: "background-color: black; opacity: 0.8;",
              })}
              }
            #app {
              // border: 3px red solid;
            }
          `}
      </style>

      <div id="app" className="d-flex flex-column h-100">
        {returnTextByOrg(organization, {
          southcentralpower: (
            <img
              src="https://www.southcentralpower.com/wp-content/uploads/Ohio-South-Central_Illustrated-Footer.svg"
              id="bg-img"
            />
          ),
          austinutilities: (
            <img
              src="https://coautilities.com/wps/wcm/connect/occ/97697617-2bc0-4511-b186-8a1b58222c17/budget-bill-shutterstock_1439017064.jpg?MOD=AJPERES&CACHEID=ROOTWORKSPACE.Z18_G0L8HOC0LGEC40AMK6T8400004-97697617-2bc0-4511-b186-8a1b58222c17-n4zZb8c"
              id="bg-img"
            />
          ),
          oec: (
            <img
              src="https://okcoop.org/wp-content/uploads/2021/03/oec-nps-solar-farm.jpg"
              id="bg-img"
            />
          ),
          nisc: (
            <img
              src="https://www.nisc.coop/wp-content/uploads/2021/02/aboutus-header.jpg"
              id="bg-img"
            />
          ),
        })}

        <div className="bg"></div>
        <NavBar hideCustomers={hideCustomers} hideEmployees={hideEmployees} />
        <Container className="flex-grow-1 mt-5 main-container">
          <Switch>
            <Route
              path="/"
              exact
              render={(routerProps) => (
                <Home
                  hideCustomers={hideCustomers}
                  hideEmployees={hideEmployees}
                  setHideCustomers={setHideCustomers}
                  setHideEmployees={setHideEmployees}
                />
              )}
            />
            <Route path="/profile" component={Profile} />
            <Route path="/permissions" component={Permissions} />
            <Route path="/login" component={Login} />
            <Route path="/org" component={OrgManagement} />
            <Route path="/apps" component={Applications} />
            <Route path="/tenants" component={Tenants} />
          </Switch>
        </Container>
        {/* <Footer /> */}
      </div>
    </Router>
  );
};

export default App;
